import React from 'react'

const NotesScreen = (props) => {
  return (
    <div>NotesScreen</div>
  )
}

export default NotesScreen